export default __webpack_public_path__ + "c6eee3f8a948b99604242c762a707853.png";